import { fetchHoj } from './client';
import type { Product, ProductList } from './types';

export interface ListProductsParams {
  cursor?: string;
  limit?: number;
  channelIds?: string;
  signal?: AbortSignal;
}

export async function listProducts(params: ListProductsParams = {}): Promise<ProductList> {
  return fetchHoj<ProductList>('/v1/products', {
    query: {
      limit: params.limit ?? 25,
      cursor: params.cursor,
      channelIds: params.channelIds,
    },
    signal: params.signal,
  });
}

export async function getProduct(id: string, signal?: AbortSignal): Promise<Product> {
  const res = await fetchHoj<{ data: Product }>(`/v1/products/${encodeURIComponent(id)}`, {
    signal,
  });
  return res.data;
}
